import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api';  // Ensure this path matches your API utility file

export const fetchTDS = createAsyncThunk("tds/fetchTDS", async (searchText) => {
  const response = await api.post("/tds",{ search: searchText });
  return response.data.data;
});

export const addTDS = createAsyncThunk(
  "tds/addTDS",
  async (tdsData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-user", tdsData);
      dispatch(fetchTDS());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to save user");
    }
  }
);

export const deletetds = createAsyncThunk(
  "tds/deletetds",
  async (tdsId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-tds/${tdsId}`);
      dispatch(fetchTDS());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to delete user");
    }
  }
);

// Define the initial state and slice
const tdsSlice = createSlice({
  name: "tdsData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    opentdsModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closetdsModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTDS.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTDS.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchTDS.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addTDS.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addTDS.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addTDS.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deletetds.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deletetds.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deletetds.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { opentdsModal, closetdsModal, clearError } = tdsSlice.actions;
export default tdsSlice.reducer;
export { tdsSlice };